'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _arrowLeft = require('dibs-vg/dist/react/arrow-left');

var _arrowLeft2 = _interopRequireDefault(_arrowLeft);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalBackButton = function ModalBackButton(props) {
    var theme = props.theme,
        className = props.className,
        onClick = props.onClick,
        disabled = props.disabled;

    if (!theme) {
        return null;
    }

    var wrapperClass = (0, _classnames3.default)(theme.backButtonClickableArea, className, (0, _defineProperty3.default)({}, theme.backButtonDisabled, disabled));

    return _react2.default.createElement(
        'div',
        { className: wrapperClass, onClick: disabled ? function () {} : onClick },
        _react2.default.createElement(
            'div',
            { className: theme.backIcon },
            _react2.default.createElement(_arrowLeft2.default, null)
        )
    );
};

ModalBackButton.displayName = 'ModalBackButton';

exports.default = ModalBackButton;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-elements/lib/ModalBackButton/index.js
// module id = ./node_modules/dibs-elements/lib/ModalBackButton/index.js
// module chunks = 4